// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { NullableOption } from '@microsoft/microsoft-graph-types';
import { Constants } from '../constants';

export const utils = {
  delay: (ms: number): Promise<void> => {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },

  resetHomeLocation: (page: string): void => {
    if (page === Constants.SCREENS.MEETING) {
      window.location.href = window.location.href.split('?')[0];
    }
  },

  getACSMeetingUrlFromCalendarEvent: (bodyContent: NullableOption<string> | undefined): string | undefined => {
    let matchedResult: string | undefined;
    Constants.ACS_GROUPCALL_CHAT_PATTERN.forEach((pattern) => {
      const matchingResult = bodyContent?.match(pattern);
      if (matchingResult) {
        // the '&' gets replaced as '&amp;' within html, hence the sanitization of the url
        // https://stackoverflow.com/questions/8418938/replace-amp-to
        matchedResult = matchingResult[0].replaceAll('&amp;', '&');
      }
    });
    return matchedResult;
  },

  isDevEnvironment: (): boolean => {
    return process.env.NODE_ENV === 'development';
  },

  removeUsersFromChatThread: async (
    functionsAppToken: string,
    chatThreadId: string,
    userIdsToRemove: string[]
  ): Promise<Response> => {
    const userRemovalUrl = 'api/removeUserFromChat?chatThreadId=' + chatThreadId;

    return await fetch(userRemovalUrl, {
      body: JSON.stringify(userIdsToRemove),
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${functionsAppToken}`
      })
    });
  }
};
